import { ConfigurableIntegrationSettingsAdmin } from '../../containers/account/integrations/ConfigurableIntegrationSettingsAdmin';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export function AdminAccountConfigureIntegrationPage() {
	return (
		<AdminDashboardPageLayout>
			<ConfigurableIntegrationSettingsAdmin />
		</AdminDashboardPageLayout>
	);
}
